//@flow
import QRCode from 'qrcode';

export async function generateQR(text: string) {
  try {
    const result = await QRCode.toDataURL(text);
    return result;
  } catch (err) {
    throw new Error('Error generating QR code');
  }
}
